import { useCallback, useRef } from 'react'

import {
  MixpanelEvents,
  PlayerEvents,
} from '@/utils/analytics/types/playerEvents'

import { VideoFeedEvent } from '../types/types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TrackEventFn = (eventName: MixpanelEvents, data?: any) => void

export function useStreamLatencyTracker(trackEvent: TrackEventFn) {
  const startTimeRef = useRef<number>(performance.now())
  const receivedTimeRef = useRef<number | null>(null)

  const onVideoFeedEvent = useCallback((event: VideoFeedEvent) => {
    if (event === VideoFeedEvent.Received) {
      receivedTimeRef.current = performance.now()
    }
  }, [])

  const trackLatency = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (playerType: 'mse' | 'hls', mixpanelData?: any) => {
      const now = performance.now()
      const receivedTime = receivedTimeRef.current

      trackEvent(PlayerEvents.liveStreamLatency, {
        total_ms: Math.round(now - startTimeRef.current),
        request_ms: receivedTime
          ? Math.round(receivedTime - startTimeRef.current)
          : null,
        buffer_ms: receivedTime ? Math.round(now - receivedTime) : null,
        player_type: playerType,
        ...mixpanelData,
      })
    },
    [trackEvent]
  )

  return { onVideoFeedEvent, trackLatency }
}
